// extracted by mini-css-extract-plugin
module.exports = {"loading_box":"FJSpinLoading_loading_box__Arfs8","rotate":"FJSpinLoading_rotate__3igJ1","spin_rotate":"FJSpinLoading_spin_rotate__1BO0z"};